import React, { useContext } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import routes from './routes';
import SignIn from './containers/Auth/SignIn';
import ForgotPassword from './containers/Auth/ForgotPassword';
import SignUp from './containers/Auth/SignUp';
import Programs from './containers/Programs';
import Courses from './containers/Courses';
import MobileCourses from './containers/Courses/MobileCourses';
import LogOut from './containers/Auth/LogOut';
import Progress from './containers/Progress';
import Profile from './containers/Profile';
import Certificate from './containers/Certificate';
import VerifyEmail from './containers/Auth/VerifyEmail';
import ResetPassword from './containers/Auth/ResetPassword';
import Membership from './containers/Membership';
import MemberCertificate from './containers/MemberCertificate';
import GetStarted from './containers/Home';
import Settings from './containers/Settings';
import Manage from './containers/Manage';
import Member from './containers/Member';
import { ViewportContext } from './providers/ViewportProvider';
import { isEnterprise } from './config';
import { makeSelectUser } from './store/selectors';
import { ROLE } from './constants';

const Root = () => {
  const { width } = useContext(ViewportContext);
  const user = useSelector(makeSelectUser());

  return (
    <Switch>
      <Route exact path={routes.CERTIFICATE} component={Certificate} />
      <Route exact path={routes.INDEX} component={GetStarted} />
      <Route exact path={routes.SIGN_IN} component={SignIn} />
      <Route exact path={routes.SIGN_UP} component={SignUp} />
      <Route exact path={routes.FORGOT_PASSWORD} component={ForgotPassword} />
      <Route exact path={routes.RESET_PASSWORD} component={ResetPassword} />
      <Route exact path={routes.VERIFY_EMAIL} component={VerifyEmail} />
      <Route exact path={routes.PROFILE} component={Profile} />
      <Route exact path={routes.PROGRESS} component={Progress} />
      <Route exact path={routes.MEMBERSHIP} component={Membership} />
      <Route exact path={routes.SETTINGS} component={Settings} />
      {isEnterprise && <Route exact path={routes.MANAGE} component={Manage} />}
      <Route exact path={routes.MEMBER} component={Member} />
      <Route
        exact
        path={routes.MEMBER_CERTIFICATE}
        component={MemberCertificate}
      />
      <Route exact path={routes.SIGN_OUT} component={LogOut} />
      {user && user.role !== ROLE.Manager ? (
        <>
          <Route exact path={routes.PROGRAMS} component={Programs} />
          <Route
            exact
            path={routes.COURSES}
            component={width > 640 ? Courses : MobileCourses}
          />
          <Route
            exact
            path={routes.COURSES_WITH_ID}
            component={width > 640 ? Courses : MobileCourses}
          />
        </>
      ) : null}
    </Switch>
  );
};

export default Root;
